import customComponents from '@/constants/theme.components';
import customTheme from '@/constants/theme.custom';
import { theme as Theme } from '@/constants/theme';

const injectThemeProps = (theme: typeof Theme) => {
  return {
    ...theme,
    colors: { ...theme.colors, ...customTheme.colors },
    components: { ...theme.components, ...customComponents },
  };
};

export default injectThemeProps;
